<template>
    <v-dialog v-model="showDialog" max-width="1500px" persistent scrollable width="80%">
      <v-card class="addNewSite-modal">
        <v-card-title class="bg-gray-light">
          <span class="text-h5" style="font-size: 1.2rem !important;">{{ $t(nameLabel) }}</span>
          <v-btn class="ml-auto" icon @click.prevent="handleConfirmCloseModal">
            <v-icon id="close-button">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="height: auto;">
          <v-container style="max-width:1435px !important;" class="pt-0 pb-0">
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="row mt-0">
                <div class="col-xl-6 col-sm-12">
                  <div class="d-flex justify-content-start">
                    <h6 class="mb-1 label-black">{{ $t("labels.siteManager.connectDB.Host") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger">*</h5>
                  </div>
                  <v-text-field maxlength="255" @keypress.13.prevent v-model="connectInfo.host" 
                    hide-details="auto" outlined dense :rules="hostRules"
                  ></v-text-field>
                </div>
                <div class="col-xl-6 col-sm-12">
                    <div class="d-flex justify-content-start">
                        <h6 class="mb-1 label-black">{{ $t("labels.siteManager.connectDB.Post") }}</h6>
                        <h5 class="text-danger mb-0 h-text-danger">*</h5>
                    </div>
                     <v-text-field maxlength="5" @paste="onPaste"
                      @keypress="validateNumber($event)" v-model="connectInfo.post" hide-details="auto" outlined dense
                      :rules="postRules"
                    >
                    </v-text-field>
                </div>
              </div>
              <div class="row mt-0">
                <div class="col-6">
                  <div class="d-flex justify-content-start">
                    <h6 class="mb-1 label-black">{{ $t("labels.siteManager.connectDB.Database") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger">*</h5>
                  </div>
                  <v-text-field maxlength="255" @keypress.13.prevent v-model="connectInfo.database" 
                    hide-details="auto" outlined dense :rules="databaseRules"
                  ></v-text-field>
                </div>
              </div>
              <div class="row mt-0">
                <div class="col-xl-6 col-sm-12">
                  <div class="d-flex justify-content-start">
                    <h6 class="mb-1 label-black">{{ $t("labels.siteManager.connectDB.UserName") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger">*</h5>
                  </div>
                  <v-text-field maxlength="255" @keypress.13.prevent v-model="connectInfo.userName" 
                    hide-details="auto" outlined dense :rules="userNameRules"
                  ></v-text-field>
                </div>
                <div class="col-xl-6 col-sm-12">
                  <div class="d-flex justify-content-start">
                    <h6 class="mb-1 label-black">{{ $t("labels.siteManager.connectDB.Password") }}</h6>
                    <h5 class="text-danger mb-0 h-text-danger">*</h5>
                  </div>
                  <v-text-field hide-details="auto" @keypress.13.prevent
                    :type="showPassword ? 'text' : 'password'" maxlength="255"
                    :append-icon="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                    @click:append="showPassword = !showPassword"
                    outlined dense v-model="connectInfo.password" ref="password" :rules="passwordRules"
                    ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed style="background-color: #3d76ad"
            :disabled="!connectInfo.host || !connectInfo.post || !connectInfo.database || !connectInfo.userName || !connectInfo.password" @click.prevent="handleTestConnect">
            <span class="text-white">{{ $t("labels.siteManager.TestConnection") }}</span>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn v-if="!checkDetail" class="text-white mr-1" style="background-color: #3d76ad" text @click.prevent="handleSaveData">
            {{ $t("labels.siteManager.save") }}
          </v-btn>
          <v-btn v-if="!checkDetail" class="bg-secondary text-white" text @click.prevent="handleConfirmCloseModal">
            {{ $t("labels.siteManager.cancel") }}
          </v-btn>
          <v-btn v-if="checkDetail" class="bg-secondary text-white" text @click.prevent="handleConfirmCloseModal">
            {{ $t("labels.siteManager.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
      </v-overlay>
    </v-dialog>
</template>

<script>
import { EventBus } from '@/utils/eventBus.js';
import { mapActions } from 'vuex';
import $ from 'jquery';
import { CONSTANTS } from '@/utils/constant';

export default {
  name: "ConnectDBModal",
  props: ['visible'],
  data() {
    return {
        valid: false,
        loading: false,
        showDialog: false,
        showPassword: false,
        editFlag: false,
        checkDetail: false,
        connectDefault: null,
        connectInfo: {
            host: null,
            post: null,
            database: null,
            userName: null,
            password: null,
        },
        ERROR_CODE: '',
        nameLabel: "",
        hostRules: [
            (value) => !!value || this.$t("labels.siteManager.connectDB.Host") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        postRules: [
          (value) => !!value || this.$t("labels.siteManager.connectDB.Post") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        databaseRules: [
          (value) => !!value || this.$t("labels.siteManager.connectDB.Database") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        userNameRules: [
          (value) => !!value || this.$t("labels.siteManager.connectDB.UserName") + this.ERROR_CODE['IS_REQUIRED'],
        ],
        passwordRules: [
          (value) => !!value || this.$t("labels.siteManager.connectDB.Password") + this.ERROR_CODE['IS_REQUIRED'],
        ],
    }
  },
  updated() {
    if (this.$i18n.locale !== this.currentLocale) {
      this.currentLocale = this.$i18n.locale;
    }
  },
  beforeDestroy() {
    this.loading = false;
  },
  computed: {
  },
  watch: {
    '$i18n.locale': async function (currentLang) {
      // ========================================================== start import ERROR_CODE by language
      // ==============================================================================================
      await import(`@/utils/errors/site/${currentLang}.js`)
        .then((DATA) => {
          this.ERROR_CODE = DATA.ERROR_CODE
        })
        .catch(async () => {
          await import(`@/utils/errors/site/${currentLang}.js`)
            .then((DATA) => {
              this.ERROR_CODE = DATA.ERROR_CODE
            })
        })
      // ==============================================================================================
      // =========================================================== stop import ERROR_CODE by language
    },
  },
  async beforeMount() {
    // ========================================================== start import ERROR_CODE by language
    // ==============================================================================================
    const currentLang = this.$i18n.locale
    await import(`@/utils/errors/site/${currentLang}.js`)
      .then((DATA) => {
        this.ERROR_CODE = DATA.ERROR_CODE
      })
      .catch(async () => {
        await import(`@/utils/errors/site/${currentLang}.js`)
          .then((DATA) => {
            this.ERROR_CODE = DATA.ERROR_CODE
          })
      })

    // ==============================================================================================
    // =========================================================== stop import ERROR_CODE by language
  },
  beforeCreate() {
    this.loading = true;
  },
  created() {
    EventBus.$on('handleOpenConnectDBModal', (value) => {
      this.showDialog = value.flag;
      if (value.flag) {
        $('#main-header').css("pointer-events", "none");
      } else {
        $('#main-header').css("pointer-events", "");
      }
      this.nameLabel = value.nameLabel;
      this.$refs.form?.resetValidation();
      this.connectDefault = value.data;
      this.connectInfo.host = value.data.ip ?? null;
      this.connectInfo.post = value.data.port ?? null;
      this.connectInfo.database = value.data.database ?? null;
      this.connectInfo.userName = value.data.userName ?? null;
      this.connectInfo.password = value.data.password ?? null;
      this.editFlag = value.editFlag;
      this.checkDetail = value.checkDetail;
    });
  },
  mounted() {
  },
  methods: {
    ...mapActions("file", {
      testConnection: "testConnection"
    }),
    validateNumber(event) {
      const charCode = event.keyCode || event.which;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    onPaste(event){
      if (isNaN(event.clipboardData.getData('text'))) {
        event.preventDefault();
      }
    },
    handleSaveData() {
        this.$refs.form.validate()
        if (!this.$refs.form.validate()) {
          return;
        }
        this.showDialog = false;
        EventBus.$emit('handleCloseConnectDBModal', this.connectInfo);
        $('#main-header').css("pointer-events", "");
        this.handleResetFormItem();
    },
    handleConfirmCloseModal() {
      if(this.checkDetail){
        this.connectInfo.host = this.connectDefault.ip ?? null;
        this.connectInfo.post = this.connectDefault.port ?? null;
        this.connectInfo.database = this.connectDefault.database ?? null;
        this.connectInfo.userName = this.connectDefault.userName ?? null;
        this.connectInfo.password = this.connectDefault.password ?? null;
        this.showDialog = false;
        EventBus.$emit('handleCloseConnectDBModal', this.connectInfo);
        $('#main-header').css("pointer-events", "");
      }
      else{
        this.commonConfirmVue(this.ERROR_CODE['CF_052_01_01'], () => {
          this.connectInfo.host = this.connectDefault.ip ?? null;
          this.connectInfo.post = this.connectDefault.port ?? null;
          this.connectInfo.database = this.connectDefault.database ?? null;
          this.connectInfo.userName = this.connectDefault.userName ?? null;
          this.connectInfo.password = this.connectDefault.password ?? null;
          this.showDialog = false;
          EventBus.$emit('handleCloseConnectDBModal', this.connectInfo);
          $('#main-header').css("pointer-events", "");
        });
      }
    },
    handleResetFormItem() {
      this.connectInfo = {
          host: null,
          post: null,
          database: null,
          userName: null,
          password: null,
      };
      this.$refs.form?.resetValidation();
    },
    handleTestConnect(){
      this.loading = true;
        var connectString = "Host=" + this.connectInfo.host + ";" 
          + "Port=" + this.connectInfo.post + ";" 
          + "Username=" + this.connectInfo.userName + ";"
          + "Password=" + this.connectInfo.password + ";"
          + "Database=" + this.connectInfo.database;
        var request = {
          connectionString: connectString,
          databaseName: this.connectInfo.database
        }
        this.testConnection(request)
        .then(response => {
          if(response.code === CONSTANTS.S_TC_CNSS){
            this.loading = false;
            this.commonInfoVue(this.ERROR_CODE[response.code], 'success');
          }
          else{
            this.loading = false;
            this.commonErrorVue(this.ERROR_CODE[response.code], 'warning');
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          if (err.code != undefined)
            this.commonErrorVue(this.ERROR_CODE[err.code], 'warning');
      })
    }
  }
}
</script>

<style scoped lang="scss">

.v-card__actions {
  border-top: 1px solid #ebebeb;
}

.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  overflow-y: auto;
  top: 100px;
  left: 0;
}

.label-black {
  color: black !important;
}

.h-text-danger {
  height: 2px !important;
}

.v-input--has-state fieldset {
  border: 2px solid red !important;
}

.v-messages__message {
  color: red !important;
  padding-left: 0px !important;
  font-size: 15px !important;
}

.input-port input[type='number'] {
  -moz-appearance: textfield;
}

.input-port input::-webkit-outer-spin-button,
.input-port input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

@media only screen and (max-width: 500px) and (max-height: 900px) {
  .addNewSite-modal {
    margin-top: 5vh !important;
  }
}

::v-deep{
  .v-dialog{
    overflow: hidden;
  }
  .v-card__text{
    width: 100% !important;
  }
  @media (max-width: 800px) {
    .v-card__text{
      .container{
        padding : 0;
      }
    }
  }
}
::v-deep{
  .v-dialog {
    box-shadow: none !important;
  }
}
</style>
